import { Input } from 'antd';
import './style.scss';
import { InputRef, SearchProps } from 'antd/es/input';
import { forwardRef, LegacyRef } from 'react';
const { Search } = Input;

type SearchBoxProps = SearchProps & {
  label?: React.ReactNode;
  showLabel?: boolean;
};

const SearchBox = forwardRef(
  (
    {
      label,
      placeholder,
      onSearch,
      onChange,
      disabled,
      showLabel = true,
      ...props
    }: SearchBoxProps,
    ref: LegacyRef<InputRef>,
  ) => {
    const search = (
      <Search
        ref={ref}
        className="search-box"
        placeholder={placeholder}
        onSearch={onSearch}
        onChange={onChange}
        allowClear={true}
        disabled={disabled}
        {...props}
      />
    );

    if (!showLabel) return search;

    return (
      <div>
        <div className="search-label">{label || 'Search'}</div>
        {search}
      </div>
    );
  },
);

SearchBox.displayName = 'SearchBox';

export default SearchBox;
